//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            showHoverBg: false,
            itemOptions: {
                width: 139,
                height: 37
            },
            items: [{
                dropAreaIndex: -1,
                itemPositionIndex: -1,
                correctDropAreaIndex: 0,
                image: `/images/game/w4d2/orange_50_${this.$lang.locale}.png`,
            }, {
                dropAreaIndex: -1,
                itemPositionIndex: -1,
                correctDropAreaIndex: 0,
                image: `/images/game/w4d2/orange_52_${this.$lang.locale}.png`,
            }, {
                dropAreaIndex: -1,
                itemPositionIndex: -1,
                correctDropAreaIndex: 0,
                image: `/images/game/w4d2/orange_58_${this.$lang.locale}.png`,
            }, {
                dropAreaIndex: -1,
                itemPositionIndex: -1,
                correctDropAreaIndex: 1,
                image: `/images/game/w4d2/blue_44_${this.$lang.locale}.png`,
            }, {
                dropAreaIndex: -1,
                itemPositionIndex: -1,
                correctDropAreaIndex: 1,
                image: `/images/game/w4d2/blue_46_${this.$lang.locale}.png`,
            }, {
                dropAreaIndex: -1,
                itemPositionIndex: -1,
                correctDropAreaIndex: 1,
                image: `/images/game/w4d2/blue_52_${this.$lang.locale}.png`,
            }, {
                dropAreaIndex: -1,
                itemPositionIndex: -1,
                correctDropAreaIndex: 2,
                image: `/images/game/w4d2/green_44_${this.$lang.locale}.png`,
            }, {
                dropAreaIndex: -1,
                itemPositionIndex: -1,
                correctDropAreaIndex: 2,
                image: `/images/game/w4d2/green_47_${this.$lang.locale}.png`,
            }, {
                dropAreaIndex: -1,
                itemPositionIndex: -1,
                correctDropAreaIndex: 2,
                image: `/images/game/w4d2/green_49_${this.$lang.locale}.png`,
            }, {
                dropAreaIndex: -1,
                itemPositionIndex: -1,
                correctDropAreaIndex: 3,
                image: `/images/game/w4d2/lila_49_${this.$lang.locale}.png`,
            }, {
                dropAreaIndex: -1,
                itemPositionIndex: -1,
                correctDropAreaIndex: 3,
                image: `/images/game/w4d2/lila_55_${this.$lang.locale}.png`,
            }, {
                dropAreaIndex: -1,
                itemPositionIndex: -1,
                correctDropAreaIndex: 3,
                image: `/images/game/w4d2/lila_62_${this.$lang.locale}.png`,
            }],
            dropAreas: [
                {
                    xMin: 425,
                    xMax: 595,
                    yMin: 180,
                    yMax: 360,
                    itemPositions: []
                },
                {
                    xMin: 595,
                    xMax: 765,
                    yMin: 180,
                    yMax: 360,
                    itemPositions: []
                },
                {
                    xMin: 765,
                    xMax: 935,
                    yMin: 180,
                    yMax: 360,
                    itemPositions: []
                },
                {
                    xMin: 935,
                    xMax: 1105,
                    yMin: 180,
                    yMax: 360,
                    itemPositions: []
                }
            ],
            supplementaryQuestions: [
                {
                    clicked: false,
                    correct: false
                },
                {
                    clicked: false,
                    correct: true
                },
                {
                    clicked: false,
                    correct: true
                },
                {
                    clicked: false,
                    correct: false
                }
            ]
        };
    },

    computed: {
        result () {
            let numCorrect = this.dropAreas.filter((dropArea, index) => {
                return this.items.filter(item => item.dropAreaIndex === index && item.dropAreaIndex === item.correctDropAreaIndex).length === 3;
            }).length;
            let numWrong = this.dropAreas.length - numCorrect;

            let numQuestionsCorrect = this.supplementaryQuestions.filter(question => question.correct && question.clicked).length;
            let numQuestionsWrong = this.supplementaryQuestions.filter(question => question.correct && !question.clicked).length + 
                this.supplementaryQuestions.filter(question => !question.correct && question.clicked).length;

            return this.$game.getDragDropResult(numCorrect + numQuestionsCorrect, numWrong + numQuestionsWrong);
        }
    },

    created () {
        _.shuffle(this.items).forEach((item, index) => {
            this.$set(item, 'x', 460 + (index % 4 * 160));
            this.$set(item, 'y', 520 + (Math.floor(index / 4) * 60));
        });

        let itemPositionHeight = 60;

        this.dropAreas.forEach((dropArea, index) => {
            for (let y = dropArea.yMin; y < dropArea.yMax; y = y + itemPositionHeight) {
                dropArea.itemPositions.push({
                    xMin: dropArea.xMin,
                    xMax: dropArea.xMax,
                    yMin: y,
                    yMax: y.itemPositionHeight
                });
            }
        });
    },

    methods: {
        dragend (item, { x, y }) {
            this.showHoverBg = false;

            item.x = x;
            item.y = y;
            item.itemPositionIndex = -1;
            item.dropAreaIndex = this.dropAreas.findIndex((area, index) =>
                x >= area.xMin - this.itemOptions.width / 2 &&
                x <= area.xMax - this.itemOptions.width / 2 &&
                y >= area.yMin - this.itemOptions.height / 2 &&
                y <= area.yMax
            );

            if (item.dropAreaIndex !== -1) {
                this.$nextTick(() => {
                    let dropArea = this.dropAreas[item.dropAreaIndex];

                    item.itemPositionIndex = dropArea.itemPositions.findIndex((itemPosition, itemPositionIndex) => !this.isItemPositionOccupied(item.dropAreaIndex, itemPositionIndex));

                    if (item.itemPositionIndex !== -1) {
                        let itemPosition = dropArea.itemPositions[item.itemPositionIndex];

                        item.x = itemPosition.xMin + 12.5;
                        item.y = itemPosition.yMin + 7;
                    }
                });
            }
        },
        isItemPositionOccupied (dropAreaIndex, itemPositionIndex) {
            return this.items.some(item => item.dropAreaIndex === dropAreaIndex && item.itemPositionIndex === itemPositionIndex);
        }
    }
};
